import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloMinusIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path d='M5 10L15 10' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </EloBaseIcon>
)
